import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@/components/ThemeProvider";
import { isLocalRateLimitError, isRateLimitError } from "@/lib/apiRateLimit";
import { I18nProvider } from "./components/providers/i18nProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 30s — avoids the refetch storm on focus
      // and on component mount while keeping interactive data responsive.
      // Per-query overrides (`staleTime` on useQuery) still apply.
      staleTime: 30 * 1000,
      // Keep inactive cache entries for 5 minutes so nav-back feels instant.
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) =>
        !isRateLimitError(error) &&
        !isLocalRateLimitError(error) &&
        failureCount < 1,
    },
  },
});

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <I18nProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider
          attribute="class"
          defaultTheme="system"
          enableSystem
          disableTransitionOnChange
        >
          {children}
        </ThemeProvider>
      </QueryClientProvider>
    </I18nProvider>
  );
}
